import React from 'react'

import { useGlobalStore } from '../stores/global'

const Availability = () => {
  const language = process.env.GATSBY_SITE_LANGUAGE
  const { available, localTime } = useGlobalStore()

  // Opening status is calculated in the browser; avoid an incomplete claim
  // such as "Unavailable until" in the generated HTML.
  if (!localTime) return null

  return (
    <div className="text-10 lg:text-12">
      <span
        className={`inline-block w-2 h-2 mr-1 leading-none rounded-full ${
          available ? 'bg-aqua-500' : 'bg-red-400'
        }`}
      />

      {language === 'en' && (
        <>
          {available ? 'Available' : 'Unavailable'} until {localTime}
        </>
      )}
      {language === 'it' && (
        <>
          {available ? 'Disponibile' : 'Non disponibile '} fino alle {localTime}
        </>
      )}
    </div>
  )
}

export default Availability
